export const hCaptchaUtils = {
  verifyCaptcha: async (token) => {
    // For development/testing, just validate token exists
    // if (!hCaptchaUtils.getCaptchaSiteKey()) {
    //   return !!token
    // }

    try {
      const response = await fetch(`${hCaptchaUtils.getCaptchaUrl()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-captcha-token': token,
        },
      })
      const data = await response.json()
      return data.success
    } catch (error) {
      return false
    }
  },

  // Common methods for forms
  getCaptchaSiteKey: () => process.env.HCAPTCHA_SITE_KEY,
  getCaptchaUrl: () => process.env.HCAPTCHA_LAMBDA_URL,

  // Common handlers
  handleVerify: (component, token) => {
    component.captchaToken = token
    component.captchaValid = true
  },

  handleError: (component, error) => {
    component.captchaValid = false
    component.captchaToken = null
  },

  handleExpire: (component) => {
    component.captchaValid = false
    component.captchaToken = null
  },
}

// Mixin to add hCaptcha functionality to forms
export const hCaptchaMixin = {
  data() {
    return {
      captchaSiteKey: process.env.HCAPTCHA_SITE_KEY,
      captchaToken: null,
      captchaValid: false,
    }
  },

  methods: {
    onCaptchaVerify(token) {
      this.captchaToken = token
      this.captchaValid = true
      // Emit to parent
      this.$emit('captcha-verify', token)
    },

    onCaptchaError(error) {
      this.captchaValid = false
      this.captchaToken = null
      this.$emit('captcha-error', error)
    },

    onCaptchaExpired() {
      this.captchaValid = false
      this.captchaToken = null
      this.$emit('captcha-expired')
    },

    async validateCaptcha(captchaToken, captchaValid) {
      if (!captchaToken || !captchaValid) {
        this.$toast.error('Please complete the captcha')
        return false
      }
      return await hCaptchaUtils.verifyCaptcha(captchaToken)
    },
  },

  computed: {
    isSubmitDisabled() {
      return !this.captchaValid
    },
  },
}
